var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._v("\n    Hold tight, logging you out...\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }